
import { CareerPath } from '../../types/game';
import { GameState } from '../GameContextTypes';

export const selectCareerPath = (state: GameState, path: CareerPath): GameState => {
  if (!state.selectedRole) return state;
  
  // Find the current career level path options
  const currentCareerLevelData = state.selectedRole.careerPath.find(
    p => p.level === state.careerLevel
  );
  
  if (!currentCareerLevelData || !currentCareerLevelData.pathOptions) return state;
  
  // Find the selected path option
  const selectedPathOption = currentCareerLevelData.pathOptions.find(
    option => option.path === path
  );
  
  if (!selectedPathOption) return state;
  
  // Apply KPI boosts from the selected path
  const updatedKpis = { ...state.kpis };
  Object.entries(selectedPathOption.kpiBoosts).forEach(([key, value]) => {
    if (key in updatedKpis) {
      updatedKpis[key as keyof typeof updatedKpis] += value;
    }
  });
  
  // Update achievements
  const pathAchievement = `Specialized in ${selectedPathOption.title} career path`;
  const updatedAchievements = [...state.achievements, pathAchievement];
  
  return {
    ...state,
    careerPath: path,
    careerTitle: selectedPathOption.title,
    kpis: updatedKpis,
    achievements: updatedAchievements
  };
};
